import * as React from "react";
import { useHistory } from "react-router-dom";
import { Box, IconButton, Typography, Divider } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Images } from "../../assets/common";
import { hasPremium } from "./../../constants/function";

import "./index.scss";
import { logout } from "../../constants/function";
import { Stack } from "@mui/material";
import SidebarMenu from "./../../components/SidebarMenu";
import AddPopup from "../AddPopup";
import BiddingPopup from "../BiddingPopup";
import OutsideClickHandler from "react-outside-click-handler";
import ApiService from "../../services/api-service";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../DropDown";
import { setLanguage } from "../../action/language";
import cookieStorage from "../../services/cookie-storage";
import TranslateIcon from "@mui/icons-material/Translate";
function Bidding({ nftDetails, onClick }) {
  return (
    <Stack
      onClick={() => onClick()}
      sx={{ cursor: "pointer", margin: "5px 0" }}
      direction="row"
      alignItems="center"
      gap="12px"
    >
      <img
        className="avatar-sm"
        src={
          nftDetails?.details
            ? nftDetails?.details?.thumbnailImg?.filePath
            : Images.music_default
        }
        alt=""
      />
      <Typography className="fs-13 faded _cp">
        {nftDetails?.details?.title}
      </Typography>
    </Stack>
  );
}

export default function SideBar({ open, toggleDrawer }) {
  const dispatch = useDispatch();
  const { availableLanguages, language } = useSelector(
    (state) => state.language
  );
  const { t, i18n } = useTranslation("common");
  const [nft, setNft] = React.useState(null);
  const [auctionHouse, setAuctionHouse] = React.useState({});
  const [bidding, setBidding] = React.useState(false);
  const [auction, setAuction] = React.useState(false);
  const [addPlaylist, setaddPlaylist] = React.useState(false);
  const history = useHistory();
  const [menu, setMenu] = React.useState(false);
  const [menuLang, setMenuLang] = React.useState(false);
  const [index, setIndex] = React.useState(0);
  const [isPremium, setPremium] = React.useState(false);
  const handleLogout = () => {
    logout();
    history.push("/");
  };
  const handelHover = (i) => {
    // setIndex(i);
  };
  React.useEffect(() => {
    setPremium(hasPremium()); // if already premium subscribed then redirect to profile page
  }, [history.location.pathname]);
  React.useEffect(() => {
    getAuctions();
    setIndex(
      history.location.pathname.includes("/app/Home")
        ? 0
        : history.location.pathname === "/app/Upgrade" ||
          history.location.pathname === "/app/Premium"
        ? 1
        : history.location.pathname === "/app/MyMusic"
        ? 2
        : history.location.pathname.includes("/app/Playlists") ||
          history.location.pathname.includes("/app/PlaylistStatics/")
        ? 3
        : history.location.pathname === "/app/Albums" ||
          history.location.pathname.includes("/app/MyAlbumDetail/")
        ? 4
        : history.location.pathname === "/app/Nft/music" ||
          history.location.pathname === "/app/Nft/studio"
        ? 5
        : history.location.pathname === "/app/Subscription"
        ? 6
        : history.location.pathname === "/app/UnlockedAssets/Music" ||
          history.location.pathname === "/app/UnlockedAssets/Playlist"
        ? 7
        : null
    );
  }, [history.location.pathname]);

  const handleBiding = (nft) => {
    setNft(nft);
    setBidding(true);
  };
  const handleAuction = async (nft) => {
    setNft(nft);
    setAuction(true);
  };

  const getAuctions = async () => {
    try {
      const response = await ApiService.BID_AND_AUCTIONS();
      setAuctionHouse({ ...response["result"] });
    } catch (error) {}
  };
  const handleLangChange = async (language) => {
    setMenuLang(false);
    try {
      const response = await ApiService.LANGUAGE(
        `language=${language}&class=web`
      );
      const { availableLanguages, languageObject, selectedLanguage, token } =
        response.result;
      if (token) cookieStorage.createCookie("Authorization", token, 1);
      dispatch(
        setLanguage({
          language: selectedLanguage,
          languageObject: languageObject,
          availableLanguages: availableLanguages,
        })
      );
      window.location.reload();
    } catch (error) {}
  };
  const getCode = () => {
    const lng = availableLanguages.filter(
      (available) => available.code === language
    );
    if (lng.length > 0) return lng[0].language;
    else return "";
  };

  return (
    <Box sx={{ position: "relative" }}>
      {open ? (
        <Box
          style={{
            width: open ? "240px" : 0,
            // backgroundColor: "#262626",
            backgroundColor: "black",
            borderRight: "0.2px solid #262626",
            height: "90vh",
            // height: "93vh",
            overflow: "scroll",
          }}
        >
          <Box sx={{ padding: "30px" }}>
            <Button
              onClick={() => {
                toggleDrawer(false);
                history.push("/app/UploadMusic");
              }}
              className={"__upload_button" + (menu ? " __open_button" : "")}
              startIcon={<AddIcon sx={{ fontSize: "24px" }} />}
              endIcon={
                <KeyboardArrowDownIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenu(!menu);
                  }}
                  className={menu ? "__180" : "__0"}
                />
              }
              sx={{ whiteSpace: "pre" }}
            >
              <span style={{ fontWeight: "600" }}>
                {t("sidebar.button.button1")}
              </span>
            </Button>
            {menu ? (
              <Button
                onClick={() => {
                  toggleDrawer(false);
                  setaddPlaylist(true);
                }}
                className="__upload_button __create_playlist"
                // startIcon={<img src={Images.playlist_hover} />}
                startIcon={<img src={Images.black_playlist} />}
                endIcon={
                  <KeyboardArrowDownIcon sx={{ visibility: "hidden" }} />
                }
              >
                <span style={{ fontWeight: "600" }}>
                  {t("sidebar.button.button2")}
                </span>
              </Button>
            ) : null}
          </Box>
          <Box>
            <Stack spacing={1.5}>
              <Typography
                color="default"
                className="fs-11 ls2-2 "
                sx={{ padding: "0 30px" }}
              >
                {t("sidebar.menu1.title")}
              </Typography>

              <SidebarMenu
                index={0}
                activeIndex={index}
                name={t("sidebar.menu1.menu1")}
                path="/app/Home"
                image={index === 0 ? Images.home_enter : Images.home_default}
                onHover={() => handelHover(null)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <SidebarMenu
                index={1}
                activeIndex={index}
                name={
                  isPremium
                    ? t("sidebar.menu1.menu2.view")
                    : t("sidebar.menu1.menu2.get")
                }
                path={isPremium ? "/app/Premium" : "/app/Upgrade"}
                image={
                  index === 1 ? Images.primium_enter : Images.premium_default
                }
                onHover={() => handelHover(1)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <Typography
                color="default"
                className="fs-11 ls2-2 mt-20"
                sx={{ padding: "0 30px" }}
              >
                {t("sidebar.menu2.title")}
              </Typography>
              <SidebarMenu
                index={2}
                activeIndex={index}
                name={t("sidebar.menu2.menu1")}
                path={"/app/MyMusic"}
                image={index === 2 ? Images.music_enter : Images.music_default}
                onHover={() => handelHover(2)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <SidebarMenu
                index={3}
                activeIndex={index}
                name={t("sidebar.menu2.menu2")}
                path={"/app/Playlists"}
                image={
                  index === 3 ? Images.playlist_enter : Images.playlist_default
                }
                onHover={() => handelHover(3)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <SidebarMenu
                index={4}
                activeIndex={index}
                name={t("sidebar.menu2.menu3")}
                path={"/app/Albums"}
                image={index === 4 ? Images.album_enter : Images.album_default}
                onHover={() => handelHover(4)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />

              <SidebarMenu
                index={5}
                activeIndex={index}
                name={t("sidebar.menu2.menu4")}
                path={"/app/Nft/music"}
                image={index === 5 ? Images.nft_y : Images.nft_default}
                onHover={() => handelHover(5)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <SidebarMenu
                index={6}
                activeIndex={index}
                name={t("sidebar.menu2.menu5")}
                path={"/app/Subscription"}
                image={index === 6 ? Images.subs_enter : Images.subs_default}
                onHover={() => handelHover(6)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
              <SidebarMenu
                index={7}
                activeIndex={index}
                name={t("sidebar.menu2.menu6")}
                path={"/app/UnlockedAssets/Music"}
                image={
                  index === 7 ? Images.unlocked_enter : Images.unlocked_default
                }
                onHover={() => handelHover(7)}
                onClick={(i) => setIndex(i)}
                toggleDrawer={() => toggleDrawer(false)}
              />
            </Stack>
          </Box>
          {auctionHouse["bidData"] && auctionHouse["bidData"].length > 0 ? (
            <Box sx={{ padding: "0 30px" }}>
              <Stack spacing={1.5} sx={{ maxHeight: "200px" }}>
                <Typography color="default" className="fs-11 mb-15 ls2-2 mt-20">
                  {t("sidebar.menu3.title")}
                </Typography>
                <Stack sx={{ overflow: "scroll", margin: "0 !important" }}>
                  {auctionHouse &&
                    auctionHouse["bidData"].map((bid, index) => (
                      <Bidding
                        nftDetails={bid}
                        key={index}
                        onClick={() => handleBiding(bid)}
                      />
                    ))}
                </Stack>
              </Stack>
            </Box>
          ) : null}

          {auctionHouse["auctionData"] &&
          auctionHouse["auctionData"].length > 0 ? (
            <Box sx={{ padding: "0 30px" }}>
              <Stack spacing={1.5} sx={{ maxHeight: "200px" }}>
                <Typography color="default" className="fs-11 mb-15 ls2-2 mt-20">
                  {t("sidebar.menu4.title")}
                </Typography>
                <Stack sx={{ overflow: "scroll", margin: "0 !important" }}>
                  {auctionHouse &&
                    auctionHouse["auctionData"].map((auction, index) => (
                      <Bidding
                        nftDetails={auction}
                        key={index}
                        onClick={() => handleAuction(auction)}
                      />
                    ))}
                </Stack>
              </Stack>
            </Box>
          ) : null}
          <div style={{ position: "relative", padding: "0 30px 100px 30px" }}>
            <Typography color="default" className="fs-11 ls2-2 mt-20 ">
              {t("setting")}
            </Typography>
            <Stack
              title={t("header.tooltip.language")}
              onClick={() => setMenuLang(!menuLang)}
              sx={{ cursor: "pointer", marginTop: "12px" }}
              direction="row"
              spacing={2}
              alignItems="center"
            >
              <TranslateIcon
                className="_cp"
                sx={{ fontSize: "18px", color: "#999999" }}
              />
              <Typography className="fs-14 _cp" sx={{ color: "#999999" }}>
                {getCode()}
              </Typography>
              <img
                src={Images.arrowdown}
                style={{
                  width: "30px",
                  transform: menuLang ? "rotate(180deg)" : "rotate(0deg)",
                }}
                className="____transform"
                alt=""
              />
            </Stack>
            {menuLang ? (
              // <OutsideClickHandler onOutsideClick={() => setMenuLang(false)}>
              <Box
                sx={{
                  // background: "#1e1e1e",
                  background: "#171515",
                  width: "max-content",
                  position: "absolute",
                  bottom: "-10px",
                  left: "55px",
                  zIndex: 10000000000000,
                  padding: "8px 15px",
                  borderRadius: "6px",
                }}
              >
                {availableLanguages.map((language, index) => (
                  <Typography
                    key={index}
                    onClick={() => handleLangChange(language["code"])}
                    className="fs-14 _cp p5"
                    sx={{
                      color: language === language["code"] ? "blue" : "white",
                    }}
                  >
                    {language?.language}
                  </Typography>
                ))}
              </Box>
            ) : // </OutsideClickHandler>
            null}
          </div>
        </Box>
      ) : null}
      {addPlaylist ? (
        <AddPopup
          api="playlist"
          title={t("addPopup.title1")}
          open={addPlaylist}
          handleClose={(e, close) => {
            setaddPlaylist(close);
            setMenu(false);
          }}
        />
      ) : null}
      {bidding ? (
        <OutsideClickHandler onOutsideClick={() => setBidding(false)}>
          <BiddingPopup
            nft={nft}
            handleClose={() => setBidding(false)}
            isAuction={false}
          />
        </OutsideClickHandler>
      ) : null}
      {auction ? (
        <OutsideClickHandler onOutsideClick={() => setAuction(false)}>
          <BiddingPopup
            nft={nft}
            isAuction={true}
            handleClose={() => setAuction(false)}
          />
        </OutsideClickHandler>
      ) : null}
    </Box>
  );
}
